var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.724 8.124 12 21.848l-5.724-5.724a1.332 1.332 0 1 0-1.885 1.885l6.667 6.667a1.33 1.33 0 0 0 1.885 0L27.61 10.009a1.332 1.332 0 1 0-1.885-1.885z"
  })));
};
export default SvgCheck;